var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',{staticClass:"mb-3"},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('h3',[_vm._v(_vm._s(_vm.question))])]),_c('v-expansion-panel-content',[_c('p',[_vm._t("answer")],2)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }